<script setup>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import FileInput from "@/components/Dashboard/Utilities/MapFlags/FileInput.vue";

const store = useStore();
const course = ref();
const file = ref({ file: "", filename: "" });
const loading = computed(() => store.getters["defaultTeetimes/isUploading"]);

const isFormValid = computed(() => {
  return file.value.file && course.value?.id;
});

const resetForm = () => {
  course.value = null;
  file.value = { file: "", filename: "" };
};

const uploadDefaultTeetimes = async () => {
  const payload = new FormData();
  payload.append("file", file.value.file);
  const res = await store.dispatch("defaultTeetimes/uploadDefaultTeetimes", {
    payload,
    courseId: course.value?.id,
  });

  if (res === "success") {
    resetForm();
  }
};
</script>
<template>
  <ContentHeader :name="'Future Default Tee-Times'" />
  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <div class="ml-2"><SelectCourse v-model="course" /></div>
            <FileInput
              v-model="file"
              :accept="'.kml,.csv'"
              :label="'CHOOSE FILE'"
            /><br />

            <div class="input-group input-group-md">
              <button
                @click="uploadDefaultTeetimes"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!isFormValid || loading"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">UPLOAD TEETIMES</span>
              </button>
              <a
                href="https://rest.tagmarshal.golf/public/defaultTeeTimesTemplate.csv"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">DOWNLOAD TEMPLATE</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
